import React from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";

import NavBarLink from "./NavBarLink";

const LoggedOutLinks = ({ pathname }) => {
	return (
		<>
			<NavBarLink
				isSelected={pathname === "/about"}
				text={_str("About")}
				path="/about"
			/>
			<NavBarLink
				text={_str("Blog")}
				path="https://theblog.okcupid.com/"
				isExternal
			/>
			<NavBarLink
				isSelected={pathname === "/careers"}
				text={_str("Careers")}
				path="/careers"
			/>
			<NavBarLink
				text={_str("Support")}
				path="https://help.okcupid.com/"
				isExternal
			/>
			<NavBarLink
				isSelected={pathname === "/press"}
				text={_str("Press")}
				path="/press"
			/>
		</>
	);
};

LoggedOutLinks.propTypes = {
	pathname: PropTypes.string.isRequired,
};

export default LoggedOutLinks;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/LoggedOutLinks.jsx